import styled from "styled-components";

// ─── Pin Badge ─────────────────────────────────────────────────────────────────
// PrioritySkillCellContainerStyled removed — replaced by inline <Flex> in JSX.
// Only PinBadgeWrapperStyled remains because visibility toggle is a dynamic
// styled-component concern that cannot be expressed as a Flex prop.

export const PinBadgeWrapperStyled = styled.div`
  visibility: ${(p) => (p.$visible ? "visible" : "hidden")};
  display: inline-flex;
  align-items: center;
`;
